<template>
    <div class="views-content--inspiration-gallery">
        <banner-generic :data="data.hero"></banner-generic>

        <section class="item-filter space--md" ref="itemFilterRef" :class="{collapsed: !isFilterExpanded, sticky: isFilterSticky}">
            <div class="container">
                <div class="row">
                        <div class="col-xs-12">
                            <div class="filter-wrapper filter-wrapper--text-only">
                                <div class="filter-wrapper--label">Application Filter</div>
                                
                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--primary" @scroll="slideOnScroll('filter-wrapper--primary')">
                                        <div class="items">
                                            <a href="#"
                                                class="category"
                                                :class="[
                                                    selectedFilter.category.length === 0 ? 'selected' : null
                                                ]" 
                                                @click.prevent="filter('reset-this-filter', 'category', null)"
                                            >
                                                <span class="title">
                                                    <span class="bolder">All</span>
                                                    <span class="light">All</span>
                                                </span>
                                            </a>

                                            <a href="#" 
                                                class="category"
                                                :class="[
                                                    selectedFilter.category.includes(category.urlsegment) ? 'selected' : null
                                                ]" 
                                                v-for="(category, index) in filterKeys.categories" 
                                                :key="index" 
                                                @click.prevent="filter(category.filterid, 'category', category.urlsegment)" 
                                                :data-id="category.filterid"
                                            >
                                                <span class="title">
                                                    <span class="bolder">{{category.title}}</span>
                                                    <span class="light">{{category.title}}</span>
                                                </span>
                                            </a>
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>

                                <button id="filter-wrapper--prev--primary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--primary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="filter-wrapper filter-wrapper--text-icon">
                                <div class="filter-wrapper--label">Colours and Profiles Filter</div>
                                
                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--secondary" @scroll="slideOnScroll('filter-wrapper--secondary')">
                                        <div class="items">
                                            <a href="#" 
                                                v-for="(tag, index) in filterKeys.tags.filter(tag => !selectedFilter.tag.includes(tag.urlsegment))"
                                                :key="index" 
                                                @click.prevent="filter(tag.filterid, 'tag', tag.urlsegment)" 
                                                :data-id="tag.filterid"
                                            >
                                                <span v-if="tag.type === 'PROFILE' && tag.profile" :style="`background-color: #ffffff; background-image: url(${tag.profile})`" class="colour-icon"></span>
                                                <span v-if="tag.type !== 'PROFILE' && tag.colour" :style="`background-color: #${tag.colour}`" class="colour-icon"></span>
                                                
                                                <span class="title">
                                                    <span class="bolder">{{tag.title}}</span>
                                                    <span class="light">{{tag.title}}</span>
                                                </span>
                                            </a>
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>

                                <button id="filter-wrapper--prev--secondary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--secondary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>

                            <div v-show="selectedFilter.tag.length > 0" class="filter-wrapper filter-wrapper--text-icon filter-wrapper--text-icon-selected">
                                <div class="separator"></div>

                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--secondary-selected" @scroll="slideOnScroll('filter-wrapper--secondary-selected')">
                                        <div class="items">
                                            <a
                                                class="selected"
                                                v-for="(tag, index) in selectedFilter.tag.map(selectedTag => filterKeys.tags[filterKeys.tags.findIndex(tag => tag.urlsegment === selectedTag)])"
                                                :key="index"
                                                :data-id="tag.filterid"
                                            >
                                                <span v-if="tag.type === 'PROFILE' && tag.profile" :style="`background-color: #ffffff; background-image: url(${tag.profile})`" class="colour-icon"></span>
                                                <span v-if="tag.type !== 'PROFILE' && tag.colour" :style="`background-color: #${tag.colour}`" class="colour-icon"></span>
                                                
                                                <span class="title">
                                                    <span class="bolder">{{tag.title}}</span>
                                                    <span class="light">{{tag.title}}</span>
                                                </span>

                                                <span
                                                    class="clear"
                                                    @click.prevent="filter(tag.filterid, 'tag', tag.urlsegment)"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <mask id="mask0_1_383" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                            <rect width="24" height="24" fill="#D9D9D9"/>
                                                        </mask>
                                                        <g mask="url(#mask0_1_383)">
                                                            <path d="M8.4 17L7 15.6L10.6 12L7 8.42499L8.4 7.02499L12 10.625L15.575 7.02499L16.975 8.42499L13.375 12L16.975 15.6L15.575 17L12 13.4L8.4 17Z" fill="#1C1B1F"/>
                                                        </g>
                                                    </svg>
                                                </span>
                                            </a>
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>

                                <button id="filter-wrapper--prev--secondary-selected" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary-selected')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--secondary-selected" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary-selected')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="filter-wrapper--separator"></div>

                            <div class="filter-wrapper--toggle">
                                <div
                                    class="toggle"
                                    @click="toggleExpandFilter"
                                >
                                    <p>
                                        Filters
                                    </p>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00024 8.99994L0.000244141 1.13342L1.00805 -6.10352e-05L7.01615 6.78355L13.0083 0.0178985L14.0002 1.13342L7.00024 8.99994Z" fill="black"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>

        <section v-show="isFilterSticky" class="item-filter--holder space--md" ref="itemFilterHolderRef"></section>

        <section class="casestudies views-casestudies">
            <div class="padding--lg">
                <div class="container" :class="{loaded: isComponentLoaded}">
                    <masonry-wall :items="displayedItems" :min-columns="2" :ssr-columns="2" :gap="masonryWallGap">
                        <template #default="{ item, index }">
                            <card 
                                :data="item" 
                                :theme="theme" 
                                location="inspirationGallery"
                                :allowPin="data.allowPinItem"
                                :class="index<itemsToShow ? '' : 'hidden'"
                                @toggleFav="toggleFav"
                            ></card>
                        </template>
                    </masonry-wall>
                </div>
            </div>
            <div class="space-bottom--xl">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="text-center">
                                <div v-if="itemsToShow < filteredItems.length || filteredItems.length > itemsToShow">
                                    <button class="button button--solid-black" @click="addtoSlicedArray()">Show More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>
    </div>
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerGeneric, Card } from "../components";
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementImage, ElementCTA, ElementColours, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";
    export default {
        name: "v-inspiration-gallery",
        mixins: [viewsElementClasses],
        components: {
            BannerGeneric,
            Card,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                theme: 'simple', // theme is passed down to the colorcard component for this page only.
                isComponentLoaded: false,
                itemsToShow: 12,
                totalItems: 0,
                items: [],
                filteredItems: [],
                displayedItems: [],
                favItems: [],
                selectedFilter: {
                    category: [],
                    tag: []
                },
                filterKeys: {
                    categories: [],
                    tags: []
                },
                intervalID: 0,
                isFilterSticky: false,
                isFilterExpanded: true,
                scrollTicking: false,
                prevWindowPosY: 0,
                masonryWallGap: 30,
            }
        },
        methods: {
            addtoSlicedArray(){
                this.itemsToShow += 12
                const itemsArray = this.convertItemsObjToArray(this.filteredItems)
                const slicedArray = itemsArray
                    .slice(0, this.itemsToShow)
                    // keep fav icon state when user click load more pagination
                    .map(slicedItem => {
                        const _slicedItem = slicedItem
                        const favItem = this.favItems.find(favItem => favItem.id === slicedItem.id)

                        if (favItem) {
                            _slicedItem.isFavorite = favItem.action === 'added' ? 'selected' : ''
                        }

                        return _slicedItem
                    })
                
                this.displayedItems = slicedArray
            },
            elementClass(elementName, index){
                let classArray = [];

                if(this.addedClasses.length>0){
                    classArray.push(this.addedClasses[index]);
                }

                return classArray;
            },
            filter(key, type, value){
                this.itemsToShow = 12;
                
                // put selected categoru and tags in variable
                // this also can be used to managed selected item class
                if (this.selectedFilter[type].includes(value)) {
                    this.selectedFilter[type].splice(this.selectedFilter[type].indexOf(value),1);
                } else {
                    this.selectedFilter[type].push(value);
                }

                if(key==='reset-this-filter'){
                    this.selectedFilter[type] = [];
                }

                // set next and prev button visibility
                if (type === 'tag') {
                    this.detectButtonVisibility();
                }
                
                let filteredList = this.filterbyTagsAndCategories(this.items, this.selectedFilter);
                const itemsArray = this.convertItemsObjToArray(filteredList)
                const slicedArray = itemsArray.slice(0, this.itemsToShow);

                this.filteredItems = itemsArray
                this.displayedItems = slicedArray
            },
            slidePrev(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3 * (-1), 0);
            },
            slideNext(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3, 0);
            },
            slideOnScroll(id) {
                const slideBuffer = 10;
                const elem = typeof id === 'string' ? document.getElementById(id) : id;
                const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

                elem.parentNode.parentNode.classList.add('no-scroll');
                if(isScrolling){
                    elem.parentNode.parentNode.classList.remove('no-scroll');
                }

                if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
                    elem.parentNode.parentNode.classList.add('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.add('is-min');
                } else {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                }
            },
            detectButtonVisibility() {
                let status = true;

                const slideItems = [
                    document.getElementById('filter-wrapper--primary'),
                    document.getElementById('filter-wrapper--secondary'),
                    document.getElementById('filter-wrapper--secondary-selected')
                ];
                const slideButtons = [
                    document.getElementById('filter-wrapper--next--primary'),
                    document.getElementById('filter-wrapper--next--secondary'),
                    document.getElementById('filter-wrapper--next--secondary-selected')
                ];

                slideItems.forEach((elem, index) => {
                    if(elem){
                        if(elem.querySelector('.items').offsetWidth<=0) status = false;
                        if(elem.querySelector('.items').offsetWidth<=elem.offsetWidth){
                            slideButtons[index].classList.add('hidden');
                        }else{
                            slideButtons[index].classList.remove('hidden');
                        }

                        this.slideOnScroll(elem);
                    }
                });

                return status;
            },
            toggleExpandFilter() {
                this.isFilterExpanded = !this.isFilterExpanded;
            },
            onScrollHandler() {
                if (!this.scrollTicking) {
                    window.requestAnimationFrame(() => {
                        const windowPosY = window.scrollY;
                        const filterPosY = this.$refs.itemFilterRef.offsetTop;
                        const filterHolderPosY = this.$refs.itemFilterHolderRef.offsetTop;
                        const navbarHeight = document.querySelector('.profile-links')?.offsetHeight || 0;
                        
                        // set sticky
                        if ((windowPosY + navbarHeight) > ((filterHolderPosY || filterPosY) + (this.$refs.itemFilterHolderRef.offsetHeight || this.$refs.itemFilterRef.offsetHeight))) {
                            this.isFilterSticky = true;
                        } else {
                            this.isFilterSticky = false;
                            this.$refs.itemFilterHolderRef.style.height = `${this.$refs.itemFilterRef.offsetHeight}px`
                        }

                        // set autocollapse
                        if (this.isFilterSticky && this.prevWindowPosY < windowPosY) {
                            this.isFilterExpanded = false;
                        }
                        this.prevWindowPosY = windowPosY;

                        this.scrollTicking = false;
                    });

                    this.scrollTicking = true;
                }
            },
            setMasonryWallGap() {
                const browserWidth = window.innerWidth;

                // desktop
                if (browserWidth >= 768) {
                    this.masonryWallGap = 30;
                } else {
                    this.masonryWallGap = 17;
                }
            },
            toggleFav(favItem) {
                const index = this.favItems.findIndex(item => item.id === favItem.id)

                if (index < 0 ) {
                    this.favItems.push(favItem)
                } else {
                    this.favItems[index] = favItem
                }
            }
        },
        mounted() {
            const app = this;

            const itemsArray = this.convertItemsObjToArray(this.data.items)
            const slicedArray = itemsArray.slice(0, this.itemsToShow);

            this.items = itemsArray
            this.filteredItems = itemsArray
            this.displayedItems = slicedArray

            this.totalItems = this.data.items.length

            this.filterKeys = this.getFilteredCatAndTagList(this.items, this.data.categories, this.data.tags);
            
            this.intervalID = setInterval(() => {
                let status = app.detectButtonVisibility();
                if(status) clearInterval(this.intervalID );
            }, 100);

            this.setMasonryWallGap();

            window.addEventListener('resize', () => {
                clearTimeout(this.intervalID);
                this.intervalID = setTimeout(() => {
                    app.detectButtonVisibility();
                    app.setMasonryWallGap();
                }, 250);
            });

            window.addEventListener('scroll', this.onScrollHandler);

            // NOTE: fix the gap between card and load more button
            setTimeout(() => {
                app.isComponentLoaded = true
            }, 500)
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    .profile-links--visible {
        .item-filter.sticky {
            top: 61px;
            padding-top: 54px;

            @media #{$hd} {
                padding-top: 20px;
            }

            &.collapsed .filter-wrapper--toggle {
                margin-top: 25px;
                margin-bottom: 25px;

                @media #{$hd} {
                    margin-top: 16px;
                    margin-bottom: 16px;
                }
            }
        }
    }

    .item-filter {
        background-color: #fffefa;
        z-index: 20;

        &.sticky {
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
            position: fixed;
            top: 0;
            margin-top: -1px !important;
            padding-top: 60px;
            width: 100%;

            @media #{$hd} {
                padding-top: 20px;
            }

            .filter-wrapper--separator {
                display: none;
            }

            .filter-wrapper--toggle {
                display: flex;
                justify-content: center;
                margin-top: 24px;
                margin-bottom: 20px;

                .toggle {
                    cursor: pointer;
                    display: flex;
                    gap: 7px;
                }

                p {
                    margin: 0;
                }

                span {
                    transition: transform 250ms ease-in-out;
                    transform: rotate(180deg);
                }
            }
        }

        &.sticky.collapsed {
            padding-top: 0;

            .filter-wrapper {
                display: none;
            }

            .filter-wrapper--toggle {
                margin-top: 29px;
                margin-bottom: 29px;
                
                @media #{$hd} {
                    margin-top: 16px;
                    margin-bottom: 16px;
                }

                span {
                    transform: rotate(0deg);
                }
            }
        }

        .filter-wrapper--toggle {
            display: none;
        }
    }

    .filter-wrapper--text-icon-selected {
        position: relative;

        .separator {
            border-bottom: 1px solid #EEECE3;
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: 2rem;
            margin-right: 2rem;

            @media #{$sm} {
                margin-left: 0;
                margin-right: 0;
            }
        }

        .clear {
            cursor: pointer;
            height: 24px;
            margin-left: 7px;

            @media #{$md} {
                margin-left: 10px;
            }
        }
    }

    .card {
        &.card--Masonry,
        &.card--masonry,
        &.card--full {
            margin-bottom: 18px;
            padding-bottom: 10px;

            @media #{$md} {
                margin-bottom: 3rem;
                padding-bottom: 2rem;
            }
        }
    }

    .items--featured {
        overflow-x: scroll;
        margin: 2rem 0;

        @media #{$md} {
            margin: 8rem 0;
            overflow-x: inherit;
        }

        .container-mobile-width {
            min-width: 62em;

            @media #{$md} {
                min-width: inherit;
            }
        }
    }
</style>


<style lang="scss">
    @import "../../scss/abstracts/variables";

    .views-casestudies {
        .card {
            &.location--inspirationGallery {
                .info--wrap {
                    align-items: flex-start;

                    .info {
                        margin-right: 1.5rem;

                        &:last-child {
                            margin-right: 0;
                        }

                        .info-item {
                            display: block;
                            height: auto;
                            width: auto;
                            margin-right: 9px;

                            @media #{$md} {
                                margin-right: 1.5rem;
                            }

                            &:last-child {
                                margin-right: 0;
                            }

                            .colour-card {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                            }

                            .solutionset-name,
                            .colour-card .info {
                                display: block;
                                font-size: 8px;
                                margin-bottom: 0;
                                margin-top: 0.5rem;
                                width: auto;
                                padding-left: 0;
                                padding-right: 0;
                                font-family: $font-primary-med;

                                @media #{$md} {
                                    font-size: 12px;
                                }

                                span {
                                    font-family: $font-primary-med;
                                }
                            }

                            &.info--solution {
                                .solutionset-name,
                                .colour-card .info {
                                    display: none;
                                }
                            }

                            &.info--colour {
                                .card {
                                    margin-bottom: 0;
                                }
                            }
                        }
                    }
                }
            }

            .card-image {
                margin-bottom: 5px;
    
                @media #{$md} {
                    margin-bottom: 2rem;
                }
            }

            .pin-button__wrap {
                display: none;

                @media #{$md} {
                    display: block;
                }
            }

            h4 {
                margin: 0 0 6px 0;

                @media #{$md} {
                    margin: 0.425em 0 0.85em 0;
                }
            }

            .solutionset-icon {
                width: 28px;
                height: 28px;
                
                @media #{$md} {
                    width: 50px;
                    height: 50px;
                }
            }

            .colour-circle--small {
                width: 28px;
                height: 28px;

                @media #{$md} {
                    width: 50px;
                    height: 50px;
                }
            }
            .colour-card .title {
                margin: 0;
            }
        }
    }

    .loaded .masonry-column {
        row-gap: 0 !important;
    }
</style>